/**
 * Lee un indice de posicionesApuesta y devuelve las coordenadas x, y de la posición en la alfombra
 * @param {*} posicion Indice dentro del arreglo de posicionesApuesta
 * @returns Coordenadas x, y de la posición en la alfombra
 */
export function obtenerCoordenadasPorPosicion(posicion) {
  // Coordenadas de las posiciones 0 a la 156
  const posicionesAlfombra = [
    // Numeros
    { x: 34, y: 198 }, // numero 0
    { x: 90, y: 246 }, // numero 1
    { x: 90, y: 198 }, // numero 2
    { x: 90, y: 150 }, // numero 3
    { x: 138, y: 246 }, // numero 4
    { x: 138, y: 198 }, // numero 5
    { x: 138, y: 150 }, // numero 6
    { x: 186, y: 246 }, // numero 7
    { x: 186, y: 198 }, // numero 8
    { x: 186, y: 150 }, // numero 9
    { x: 234, y: 246 }, // numero 10
    { x: 234, y: 198 }, // numero 11
    { x: 234, y: 150 }, // numero 12
    { x: 282, y: 246 }, // numero 13
    { x: 282, y: 198 }, // numero 14
    { x: 282, y: 150 }, // numero 15
    { x: 330, y: 246 }, // numero 16
    { x: 330, y: 198 }, // numero 17
    { x: 330, y: 150 }, // numero 18
    { x: 378, y: 246 }, // numero 19
    { x: 378, y: 198 }, // numero 20
    { x: 378, y: 150 }, // numero 21
    { x: 426, y: 246 }, // numero 22
    { x: 426, y: 198 }, // numero 23
    { x: 426, y: 150 }, // numero 24
    { x: 474, y: 246 }, // numero 25
    { x: 474, y: 198 }, // numero 26
    { x: 474, y: 150 }, // numero 27
    { x: 522, y: 246 }, // numero 28
    { x: 522, y: 198 }, // numero 29
    { x: 522, y: 150 }, // numero 30
    { x: 570, y: 246 }, // numero 31
    { x: 570, y: 198 }, // numero 32
    { x: 570, y: 150 }, // numero 33
    { x: 618, y: 246 }, // numero 34
    { x: 618, y: 198 }, // numero 35
    { x: 618, y: 150 }, // numero 36
    // Chances
    { x: 162, y: 298 }, // numero 37 - 1-12
    { x: 354, y: 298 }, // numero 38 - 13-24
    { x: 546, y: 298 }, // numero 39 - 25-36
    { x: 690, y: 150 }, // numero 40 - Fila 01
    { x: 690, y: 198 }, // numero 41 - Fila 02
    { x: 690, y: 246 }, // numero 42 - Fila 03
    { x: 114, y: 342 }, // numero 43 - 1-18
    { x: 210, y: 342 }, // numero 44 - Par (Even)
    { x: 306, y: 342 }, // numero 45 - Rojo
    { x: 402, y: 342 }, // numero 46 - Negro
    { x: 498, y: 342 }, // numero 47 - Impar (Odd)
    { x: 594, y: 342 }, // numero 48 - 19-36
    // Sexta Linea
    { x: 114, y: 270 }, // numero 49 - Sexta Linea 1, 2, 3, 4, 5, 6
    { x: 162, y: 270 }, // numero 50 - Sexta Linea 4, 5, 6, 7, 8, 9
    { x: 210, y: 270 }, // numero 51 - Sexta Linea 7, 8, 9, 10, 11, 12
    { x: 258, y: 270 }, // numero 52 - Sexta Linea 10, 11, 12, 13, 14, 15
    { x: 306, y: 270 }, // numero 53 - Sexta Linea 13, 14, 15, 16, 17, 18
    { x: 354, y: 270 }, // numero 54 - Sexta Linea 16, 17, 18, 19, 20, 21
    { x: 402, y: 270 }, // numero 55 - Sexta Linea 19, 20, 21, 22, 23, 24
    { x: 450, y: 270 }, // numero 56 - Sexta Linea 22, 23, 24, 25, 26, 27
    { x: 498, y: 270 }, // numero 57 - Sexta Linea 25, 26, 27, 28, 29, 30
    { x: 546, y: 270 }, // numero 58 - Sexta Linea 31, 32, 33, 34, 35, 36
    { x: 594, y: 270 }, // numero 59 - Sexta Linea 32, 33, 34, 35, 36
    // Calle
    { x: 66, y: 174 }, // numero 60 - Calle 0, 2, 3
    { x: 66, y: 222 }, // numero 61 - Calle 0, 1, 2
    { x: 90, y: 270 }, // numero 62 - Calle 1, 2, 3
    { x: 138, y: 270 }, // numero 63 - Calle 4, 5, 6
    { x: 186, y: 270 }, // numero 64 - Calle 7, 8, 9
    { x: 234, y: 270 }, // numero 65 - Calle 10, 11, 12
    { x: 282, y: 270 }, // numero 66 - Calle 13, 14, 15
    { x: 330, y: 270 }, // numero 67 - Calle 16, 17, 18
    { x: 378, y: 270 }, // numero 68 - Calle 19, 20, 21
    { x: 426, y: 270 }, // numero 69 - Calle 22, 23, 24
    { x: 474, y: 270 }, // numero 70 - Calle 25, 26, 27
    { x: 522, y: 270 }, // numero 71 - Calle 28, 29, 30
    { x: 570, y: 270 }, // numero 72 - Calle 31, 32, 33
    { x: 618, y: 270 }, // numero 73 - Calle 34, 35, 36
    // Esquina Superior + 0
    { x: 66, y: 270 }, // numero 74 - Esquina 0, 1, 2, 3
    { x: 114, y: 174 }, // numero 75 - Esquina 3 ,6 ,2 ,5
    { x: 162, y: 174 }, // numero 76 - Esquina 6, 9, 5, 8
    { x: 210, y: 174 }, // numero 77 - Esquina 9, 12, 8, 11
    { x: 258, y: 174 }, // numero 78 - Esquina 12 15, 11, 14
    { x: 306, y: 174 }, // numero 79 - Esquina 15, 18, 14, 17
    { x: 354, y: 174 }, // numero 80 - Esquina 18, 21, 17, 20
    { x: 402, y: 174 }, // numero 81 - Esquina 21, 24, 20, 23
    { x: 450, y: 174 }, // numero 82 - Esquina 24, 27, 23, 26
    { x: 498, y: 174 }, // numero 83 - Esquina 27, 30, 26, 29
    { x: 546, y: 174 }, // numero 84 - Esquina 30, 33, 29, 32
    { x: 594, y: 174 }, // numero 85 - Esquina 33, 36, 32, 35
    // Esquina Inferior
    { x: 114, y: 222 }, // numero 86 - Esquina 2, 5, 1, 4
    { x: 162, y: 222 }, // numero 87 - Esquina 5, 8, 4, 7
    { x: 210, y: 222 }, // numero 88 - Esquina 8, 11, 7, 10
    { x: 258, y: 222 }, // numero 89 - Esquina 11, 14, 10, 13
    { x: 306, y: 222 }, // numero 90 - Esquina 14, 17, 13, 16
    { x: 354, y: 222 }, // numero 91 - Esquina 17, 20, 16, 19
    { x: 402, y: 222 }, // numero 92 - Esquina 20, 23, 19, 22
    { x: 450, y: 222 }, // numero 93 - Esquina 23, 26, 22, 25
    { x: 498, y: 222 }, // numero 94 - Esquina 26, 29, 25, 28
    { x: 546, y: 222 }, // numero 95 - Esquina 29, 32, 28, 31
    { x: 594, y: 222 }, // numero 96 - Esquina 32, 35, 31, 34
    // Dobles Horizontal fila Superior
    { x: 66, y: 150 }, // numero 97 - 0, 3
    { x: 114, y: 150 }, // numero 98 - 3, 6
    { x: 162, y: 150 }, // numero 99 - 6, 9
    { x: 210, y: 150 }, // numero 100 - 9, 12
    { x: 258, y: 150 }, // numero 101 - 12, 15
    { x: 306, y: 150 }, // numero 102 - 15, 18
    { x: 354, y: 150 }, // numero 103 - 18, 21
    { x: 402, y: 150 }, // numero 104 - 21, 24
    { x: 450, y: 150 }, // numero 105 - 24, 27
    { x: 498, y: 150 }, // numero 106 - 27, 30
    { x: 546, y: 150 }, // numero 107 - 30, 33
    { x: 594, y: 150 }, // numero 108 - 33, 36
    // Dobles Horizontal fila Medio
    { x: 66, y: 198 }, // numero 109 - 0, 2
    { x: 114, y: 198 }, // numero 110 - 2, 5
    { x: 162, y: 198 }, // numero 111 - 5, 8
    { x: 210, y: 198 }, // numero 112 - 8, 11
    { x: 258, y: 198 }, // numero 113 - 11, 14
    { x: 306, y: 198 }, // numero 114 - 14, 17
    { x: 354, y: 198 }, // numero 115 - 17, 20
    { x: 402, y: 198 }, // numero 116 - 20, 23
    { x: 450, y: 198 }, // numero 117 - 23, 26
    { x: 498, y: 198 }, // numero 118 - 26, 29
    { x: 546, y: 198 }, // numero 119 - 29, 32
    { x: 594, y: 198 }, // numero 120 - 32, 35
    // Dobles Horizontal fila Inferior
    { x: 66, y: 246 }, // numero 121 - 0, 1
    { x: 114, y: 246 }, // numero 122 - 1, 4
    { x: 162, y: 246 }, // numero 123 - 4, 7
    { x: 210, y: 246 }, // numero 124 - 7, 10
    { x: 258, y: 246 }, // numero 125 - 10, 13
    { x: 306, y: 246 }, // numero 126 - 13, 16
    { x: 354, y: 246 }, // numero 127 - 16, 19
    { x: 402, y: 246 }, // numero 128 - 19, 22
    { x: 450, y: 246 }, // numero 129 - 22, 25
    { x: 498, y: 246 }, // numero 130 - 25, 28
    { x: 546, y: 246 }, // numero 131 - 28, 31
    { x: 594, y: 246 }, // numero 132 - 31, 34
    // Dobles Vertical Fila Superior
    { x: 90, y: 174 }, // numero 133 - 3, 2
    { x: 138, y: 174 }, // numero 134 - 6, 5
    { x: 186, y: 174 }, // numero 135 - 9, 8
    { x: 234, y: 174 }, // numero 136 - 12, 11
    { x: 282, y: 174 }, // numero 137 - 15, 14
    { x: 330, y: 174 }, // numero 138 - 18, 17
    { x: 378, y: 174 }, // numero 139 - 21, 20
    { x: 426, y: 174 }, // numero 140 - 24, 23
    { x: 474, y: 174 }, // numero 141 - 27, 26
    { x: 522, y: 174 }, // numero 142 - 30, 29
    { x: 570, y: 174 }, // numero 143 - 33, 32
    { x: 618, y: 174 }, // numero 144 - 36, 35
    // Dobles Vertical Fila Inferior
    { x: 90, y: 222 }, // numero 145 - 2, 1
    { x: 138, y: 222 }, // numero 146 - 5, 4
    { x: 186, y: 222 }, // numero 147 - 8, 7
    { x: 234, y: 222 }, // numero 148 - 11, 10
    { x: 282, y: 222 }, // numero 149 - 14, 13
    { x: 330, y: 222 }, // numero 150 - 17, 16
    { x: 378, y: 222 }, // numero 151 - 20, 19
    { x: 426, y: 222 }, // numero 152 - 23, 22
    { x: 474, y: 222 }, // numero 153 - 26, 25
    { x: 522, y: 222 }, // numero 154 - 29, 28
    { x: 570, y: 222 }, // numero 155 - 32, 31
    { x: 618, y: 222 }, // numero 156 - 35, 34
  ];

  // Devolver las coordenadas para la posición solicitada
  return posicionesAlfombra[posicion];
}